export const BILLS_LIST = "bills_list"; 
export const BILLS_LIST_SUCCESSFULL = "bills_list_successfull";
export const VENDOR_LIST = 'vendor_list';
export const VENDOR_LIST_SUCCESSFULL = "vendor_list_successfull";
export const COST_FACTOR_LIST = "cost_factor_list";
export const COST_FACTOR_LIST_SUCCESSFULL = "cost_factor_list_successfull";
export const ADD_BILLS = 'add_bill';
export const ADD_BILLS_SUCCESSFULL = 'add_bill_successfull';
